import { render, staticRenderFns } from "./CoverPhotoUpload.vue?vue&type=template&id=1dcb21b8&scoped=true&"
import script from "./CoverPhotoUpload.vue?vue&type=script&lang=js&"
export * from "./CoverPhotoUpload.vue?vue&type=script&lang=js&"
import style0 from "./CoverPhotoUpload.vue?vue&type=style&index=0&id=1dcb21b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcb21b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VFileInput,VIcon,VImg,VRow})
